import React from 'react';

const QuestionInput = ({quizOption, idx, onChangeAnswer, onChangeCorrect}) => {
  return (
    <div className="row">
      <div className="columns small-5">
        <div className="input-container">
          <label>{`Answer ${idx}`}</label>
          <div style={{ display: 'flex'}}>
            <input 
              type="text" 
              placeholder={`Enter the answer choice here.`} 
              name='answer' 
              value={quizOption.answer} 
              onChange={(e) => onChangeAnswer(e, idx)}
            />
            <input className='selection-btn' type='radio' value={`answer-${idx}`} checked={quizOption.correct} onChange={(e) => onChangeCorrect(e, idx)} />
          </div>
        </div>
      </div>
      {idx === 1 && <p className='choose-answerTxt-container'>Select the radio button next to the correct answer.</p>}
    </div>
  )
}

export default QuestionInput;